import type { ScratchArea } from '@/lib/purchase-scratch'

export function areaFromPoints(
  start: { x: number; y: number },
  end: { x: number; y: number }
): ScratchArea {
  const x = Math.min(99, Math.max(0, Math.min(start.x, end.x)))
  const y = Math.min(99, Math.max(0, Math.min(start.y, end.y)))
  return {
    x,
    y,
    width: Math.min(100 - x, Math.max(1, Math.abs(end.x - start.x))),
    height: Math.min(100 - y, Math.max(1, Math.abs(end.y - start.y))),
  }
}

/** Counts geometric coverage without reading cross-origin image pixels. */
export function markScratchCoverage(
  cells: Set<number>,
  from: { x: number; y: number },
  to: { x: number; y: number },
  width: number,
  height: number,
  radius: number
): number {
  const dx = to.x - from.x
  const dy = to.y - from.y
  const length = dx * dx + dy * dy
  for (let y = 0; y < 32; y++) {
    for (let x = 0; x < 32; x++) {
      const cx = ((x + 0.5) / 32) * width
      const cy = ((y + 0.5) / 32) * height
      const t = length
        ? Math.max(0, Math.min(1, ((cx - from.x) * dx + (cy - from.y) * dy) / length))
        : 0
      if (Math.hypot(cx - from.x - t * dx, cy - from.y - t * dy) <= radius)
        cells.add(y * 32 + x)
    }
  }
  return cells.size / 1024
}
